import { BomPartType } from 'bom/enums';
import { IElement } from 'bom/types';
import { IJobPart, IUpsertJobPartPayload } from 'jobs/types';

import { IUpsertLineFormData } from './types';

export const mapUpsertLineData = (
  data: IUpsertLineFormData,
  jobId: number,
  jobPart?: IJobPart,
  element?: IElement
): IUpsertJobPartPayload => {
  if (!jobPart) {
    return mapCreateJobPartData(data, jobId, element);
  }

  return mapUpdateJobPartData(data, jobId, jobPart, element);
};

const mapCreateJobPartData = (data: IUpsertLineFormData, jobId: number, element?: IElement) => {
  const baseBomPart = {
    bomId: jobId,
    part: data.part?.number,
    vendorNumber: data.part?.vendorNumber,
    manufacturerId: data.manufacturer?.id,
    uom: data.uom,
  };

  let descriptionData = {};
  if (!data.part?.verified) {
    descriptionData = {
      description: data.description,
      descriptionLong: data.description,
      name: data.description,
    };
  }

  let quantityData = {};
  if (element?.id) {
    quantityData = {
      addToElements: [
        {
          id: element.id,
          quantity: data.quantity,
        },
      ],
    };
  } else {
    quantityData = {
      quantity: data.quantity,
    };
  }

  return {
    bomPart: {
      ...baseBomPart,
      ...descriptionData,
      ...quantityData,
    },
  };
};

const mapUpdateJobPartData = (
  data: IUpsertLineFormData,
  jobId: number,
  jobPart: IJobPart,
  element?: IElement
) => {
  const baseBomPart = {
    bomId: jobId,
    componentId: jobPart.componentId,
    ...(jobPart.bomPartId && { bomPartId: jobPart.bomPartId }),
    ...(element?.id && { elementId: element.id }),
    part: data.part?.number,
    vendorNumber: data.part?.vendorNumber,
    manufacturerId: data.manufacturer?.id,
    uom: data.uom,
  };

  let descriptionData = {};
  if (!data.part?.verified) {
    descriptionData = {
      description: data.description,
      descriptionLong: data.description,
      name: data.description,
    };
  }

  let quantityData = {};
  if (element?.id) {
    quantityData = {
      quantity: data.quantity,
    };
  }

  let componentData = {};
  if (jobPart.type === BomPartType.COMPONENT) {
    componentData = {
      updateElements: [
        {
          id: element?.id || jobPart.elements?.[0].id,
          quantity: data.quantity,
        },
      ],
    };
  }

  return {
    bomPart: {
      ...baseBomPart,
      ...descriptionData,
      ...quantityData,
      ...componentData,
    },
  };
};
